import axios from 'axios';
import Environment from '../../utils/Environment';
import { unwrapResponse } from './apiResponse';

export interface Capability {
    hubCapabilityConfigId: string; // CAP001, CAP002, ...
    hubCapabilityNm: string;       // XDock, IN02 Shipment planning, ...
}

export const listCapabilities = async (): Promise<Capability[]> => {
    const baseURL = Environment.getHubCapabilitiesAPI();
    const response = await axios.get(baseURL);
    const data = unwrapResponse<any>(response.data);

    if (Array.isArray(data)) {
        // If response is array of strings, convert to Capability objects
        if (data.length > 0 && typeof data[0] === 'string') {
            return data.map((name: string, index: number) => ({
                hubCapabilityConfigId: `CAP${String(index + 1).padStart(3, '0')}`,
                hubCapabilityNm: name,
            }));
        }
        // If response is already Capability objects, return as-is
        return data;
    }

    return [];
};

export const getGroupPermissionsByDC = async (dc: string): Promise<{ [groupId: string]: string[] }> => {
    const baseURL = Environment.getHubGroupsAPI();
    const response = await axios.get(`${baseURL}/permissions/${encodeURIComponent(dc)}`);
    const data = unwrapResponse<any>(response.data);

    if (typeof data === 'object' && data !== null) {
        return data;
    }
    return {};
};

export const saveGroupPermissions = async (groupId: string, permissions: string[]): Promise<void> => {
    const baseURL = Environment.getHubGroupsAPI();
    await axios.post(`${baseURL}/permissions/${encodeURIComponent(groupId)}`, { permissions });
};
